import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
import { MessagingService } from 'src/app/services/api/messaging.service';
import { environment } from 'src/environments/environment';
import { DevicesocketService } from './services/api/devicesocket.service';

import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { ServicesComponent } from './pages/services/services.component';
// const config: SocketIoConfig = { url: 'http://localhost:4500/', options: {} };
const config: SocketIoConfig = { url: 'https://ecarga-maptracker.herokuapp.com/', options: {} };
import { IvyCarouselModule } from 'angular-responsive-carousel';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ComponentsModule,
    NgbModule,
    RouterModule,
    AppRoutingModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    IvyCarouselModule,
    AngularFireModule.initializeApp(environment.firebase),
    SocketIoModule.forRoot(config),
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    ServicesComponent,
  ],
  providers: [
    MessagingService, 
    DevicesocketService],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
